import { Link } from "wouter";
import { ExternalLink } from "lucide-react";
import { RockingLobsterLink } from "./RockingLobsterLink";

const interimEcosystemLinks = [
  {
    href: "https://interims.pe/",
    label: "Explore interim opportunities",
    testId: "footer-ecosystem-interims",
  },
  {
    href: "https://interim.pe/",
    label: "Search the PE directory",
    testId: "footer-ecosystem-pe-directory",
  },
  {
    href: "https://cv140.com/",
    label: "Get CV140 career advice",
    testId: "footer-ecosystem-cv140",
  },
  {
    href: "https://thecos.ai/app",
    label: "Try The COS AI app",
    testId: "footer-ecosystem-cos-ai",
  },
];

export function MarketingFooter() {
  return (
    <footer className="bg-slate-900 border-t border-slate-800">
      <div className="max-w-6xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand Column */}
          <div className="md:col-span-2">
            <Link href="/" className="flex items-center gap-3 mb-4">
              <img src="/logo-40.png" alt="The Lifecycle Canvas" className="w-10 h-10" />
              <span className="text-xl font-display font-bold text-white">
                The Lifecycle Canvas
              </span>
            </Link>
            <p className="text-sm text-slate-400 max-w-sm">
              An interactive planning tool for Interim Executives to map career transitions, identify pain points, and plan strategic interventions.
            </p>
          </div>

          {/* Navigation Column */}
          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
              Navigation
            </h3>
            <ul className="space-y-3">
              <li>
                <Link href="/" className="text-sm text-slate-400 hover:text-teal-400 transition-colors" data-testid="footer-home">
                  Home
                </Link>
              </li>
              <li>
                <Link href="/about" className="text-sm text-slate-400 hover:text-teal-400 transition-colors" data-testid="footer-about">
                  About
                </Link>
              </li>
              <li>
                <Link href="/apply" className="text-sm text-slate-400 hover:text-teal-400 transition-colors" data-testid="footer-apply">
                  Apply for Early Access
                </Link>
              </li>
              <li>
                <Link href="/sign-in" className="text-sm text-slate-400 hover:text-teal-400 transition-colors" data-testid="footer-sign-in">
                  Sign in
                </Link>
              </li>
              <li>
                <Link href="/legal" className="text-sm text-slate-400 hover:text-teal-400 transition-colors" data-testid="footer-legal">
                  Legal
                </Link>
              </li>
            </ul>
          </div>

          {/* Interim Ecosystem Column */}
          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
              Interim Ecosystem
            </h3>
            <ul className="space-y-3">
              {interimEcosystemLinks.map((link) => (
                <li key={link.testId}>
                  <a
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`${link.label} (opens in a new tab)`}
                    className="group flex items-center gap-1 text-sm text-slate-400 transition-colors hover:text-amber-400"
                    data-testid={link.testId}
                  >
                    {link.label}
                    <ExternalLink
                      className="h-3 w-3 opacity-60 transition-opacity group-hover:opacity-100"
                      aria-hidden="true"
                    />
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-slate-400">
            © {new Date().getFullYear()} The Lifecycle Canvas. All rights reserved.
          </p>
          <RockingLobsterLink testId="footer-labs-link" />
        </div>
      </div>
    </footer>
  );
}
